var _defs, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInitiation = function SvgInitiation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Initiation_svg__f56810eb-1d7e-4e52-84a5-dd1f58c32ead{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Initiation_svg__fc20dc63-1a97-4ad7-ace2-c5437c6f3e1b",
    "data-name": "Initiation"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h250v250H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Initiation_svg__f56810eb-1d7e-4e52-84a5-dd1f58c32ead",
    d: "M85.49 58.57v132.86M176.78 130.14H85.49V64.93h91.29l-21.2 32.6 21.2 32.61z"
  }))));
};

export default SvgInitiation;